import { DraftSnapshot } from "@/entities/DataAssociation/Draft.model";
import { FileSnapshot } from "@/entities/DataAssociation/File.model";

export enum LocalStorageKey {
    Labeling = "hum-labeling",
    MetricLab = "hum-metric-lab",
}

export interface LocalStorageSchema {
    [LocalStorageKey.Labeling]: {
        recentlyViewed: {
            fileSnapshot: FileSnapshot;
            draft?: DraftSnapshot;
            viewedAt: string;
        }[];
    };
    [LocalStorageKey.MetricLab]: {
        metricStack: any[];
    };
}

export const getLocalStorage = <K extends LocalStorageKey>(
    key: K,
): LocalStorageSchema[K] | null => {
    const item = localStorage.getItem(key + "-" + process.env.NODE_ENV);
    if (!item) return null;
    try {
        return JSON.parse(item) as LocalStorageSchema[K];
    } catch {
        return null;
    }
};

export const setLocalStorage = <K extends LocalStorageKey>(
    key: K,
    value: LocalStorageSchema[K],
) => {
    localStorage.setItem(
        key + "-" + process.env.NODE_ENV,
        JSON.stringify(value),
    );
};

export const clearLocalStorage = (key: LocalStorageKey) => {
    localStorage.removeItem(key + "-" + process.env.NODE_ENV);
};
